// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-dialog__body{\r\n  /* height: 700px; */\r\n  /* overflow-x: auto; */\n}\r\n", ""]);
// Exports
module.exports = exports;
